import { FC, Fragment } from "react"
import { ItemInput } from "../../../../../../../../_webui/layout/components/Form/Item/Input"
import { Translate } from "../../../../../../../../constant/Translate"
import { validatorHalfSizeProjectName } from "../../../../../../../../utils/validator/halfSize"

const { TEXT_T199, TEXT_T200, TEXT_T236 } = Translate

export const SchedulesAddAssignment: FC = () => {
  return (
    <Fragment>
      <ItemInput label={TEXT_T199} maxLength={200} name="projectNameJp" />

      <ItemInput
        label={TEXT_T200}
        maxLength={200}
        name="projectNameEn"
        rules={[validatorHalfSizeProjectName]}
      />

      <ItemInput label={TEXT_T236} maxLength={100} name="locationPersonName" />
    </Fragment>
  )
}
